import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  CseReductionRule,
  CseReductionRuleInput
} from '../../lib/types/models/cse/cse-reduction-rule'
import { IdInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createCseReductionRule = ({ id, ...data }: IdInput<CseReductionRuleInput>) => {
  return restApiClient
    .url(constructApiUrl(API.cse.createReductionRule.url, { id }))
    .post<CseReductionRule, CseReductionRuleInput>(data)
}

export const getAllCseReductionRules = (id: number, input?: PaginationRequest) => {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.cse.getAllReductionRules.url, { id }),
        input
      )
    )
    .get<PaginationResponse<CseReductionRule>>()
}

export const getCseReductionRule = (id: number, ruleId: number) => {
  return restApiClient
    .url(constructApiUrl(API.cse.getReductionRule.url, { id, ruleId }))
    .get<CseReductionRule>()
}

export const updateCseReductionRule = ({
  id,
  ruleId,
  ...data
}: CseReductionRuleInput & { id: number; ruleId: number }) => {
  return restApiClient
    .url(constructApiUrl(API.cse.updateReductionRule.url, { id, ruleId }))
    .patch<CseReductionRule, CseReductionRuleInput>(data)
}

export const deleteCseReductionRule = (id: number, ruleId: number) => {
  return restApiClient
    .url(constructApiUrl(API.cse.deleteReductionRule.url, { id, ruleId }))
    .delete()
}
